/** WebApp2 stub：听写泄漏修补在 Mobile 完整实现；Web 无听写挖空时透传。 */
export function repairLeakedTextInDictationText(text: string): string {
  return String(text || '');
}
